import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CampaignUmbrellaChildRBAC = {
  pageID: '7a2f9e4ea9ee524935e961954dfb0763',
  elementID: {
    ViewPage: 'd35fc1f0f30a0dc142cef28264b4bba5',
    Save: 'e242cec5518dbe7239c6be0c38292f1c',
    SubmitToCatMan: '90fcc1d56cbb799ae9781acc6295c350',
    Approve: '0b5d6c1f29cc04eb7bdf4a0d9f96ca52',
    BulkUpload: 'df7c060761cdaff76997c0d566e76908',
    DeleteInventoryChild: '1eadf7f4c0851a54e85d1cbd2d7738b8',
  },
} as const

export const useRBACCampaignUmbrellaChildRBAC = createUseRBAC(CampaignUmbrellaChildRBAC.elementID)

export type UseRBACCampaignUmbrellaChildRBACType = ReturnType<
  typeof useRBACCampaignUmbrellaChildRBAC
>
